import React, { useContext } from 'react';

import AiIntelligentStudio from 'components/organism/Landing/AiIntelligentStudio';
import ExecutiveSummarySection from 'components/organism/Landing/ExecutiveSummarySection';
import RecentActivities from 'components/organism/Landing/RecentActivities';
import LandingHero, { LandingCopy } from 'components/template/Landing/LandingHero';
import { RGM_HOME_PAGE } from 'constants/landingTestIds';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';

/**
 * Copy fallbacks so a tenant that flips `commonConfig.useLandingPage` without adding a
 * `landingPage` block still gets a complete page.
 */
const DEFAULT_COPY: Required<LandingCopy> = {
    greeting: 'Welcome to Asper RGM',
    headline: 'Uncover hidden revenue',
    headlineAccent: 'opportunities.',
    searchPlaceholder: 'Search Anything',
};

/**
 * RGM landing page (`/home`).
 *
 * Three bands: hero + search, Executive Summary, then the Studio grid beside Recent activities.
 * The Studio and the sidebar share one white panel, and their 2.75:1 flex ratio reproduces the
 * design's 932.6 / 339.4 split without pinning either column to a pixel width.
 */
function RgmLandingPage() {
    const { appConfig } = useContext(UserContext);
    const copy: Required<LandingCopy> = { ...DEFAULT_COPY, ...(getConfig('landingPage', appConfig) || {}) };
    // Same flag that registers the `/ask-asper` route in `App.tsx`; without it the AI Mode switch
    // would offer a destination `MainContainer` immediately redirects away from.
    const isAskAsperEnabled = getConfig('commonConfig', appConfig)?.enableAskAsper === true;

    return (
        <div data-testid={RGM_HOME_PAGE} className="landing-page-bg min-h-full w-full pb-6">
            <LandingHero copy={copy} isAskAsperEnabled={isAskAsperEnabled} />

            <div className="mt-8 flex w-full flex-col gap-5 px-10">
                <ExecutiveSummarySection />

                <div className="flex w-full items-start gap-4 rounded-[12px] bg-white p-5">
                    <div className="flex min-w-px flex-[2.75_1_0]">
                        <AiIntelligentStudio />
                    </div>
                    <RecentActivities />
                </div>
            </div>
        </div>
    );
}

export default RgmLandingPage;
